import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { UnderlineTabs } from 'ui/atoms/Tabs/UnderlineTabs'
import type { DayAheadBidEditorMode } from './useDayAheadBidTableMode'

type DayAheadBidInputModeSelectorProps = {
  activeMode: DayAheadBidEditorMode
  onModeChange: (mode: DayAheadBidEditorMode) => void
}

export function DayAheadBidInputModeSelector({
  activeMode,
  onModeChange,
}: DayAheadBidInputModeSelectorProps): ReactNode {
  const { t } = useTranslation()

  return (
    <UnderlineTabs<DayAheadBidEditorMode>
      items={[
        { id: 'table', label: t('Table') },
        { id: 'modal', label: t('Single bids') },
      ]}
      activeId={activeMode}
      onSelect={onModeChange}
      className="w-full"
    />
  )
}
